/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_AdsInputs */

const en_admin_settings_tabs_ads = /** @type {(inputs: Admin_Settings_Tabs_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ads`)
};

/**
* | output |
* | --- |
* | "Ads" |
*
* @param {Admin_Settings_Tabs_AdsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_ads = /** @type {((inputs?: Admin_Settings_Tabs_AdsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_AdsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_tabs_ads(inputs)
});
export { admin_settings_tabs_ads as "admin.settings.tabs.ads" }